function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.56522 25.0199V26.9091C5.56522 27.3113 5.87617 27.6364 6.26087 27.6364H25.7391C26.1238 27.6364 26.4348 27.3113 26.4348 26.9091V25.0199C26.4348 22.9508 25.2584 21.105 23.4372 20.3159C21.312 19.3959 18.8097 18.929 16 18.929C13.1903 18.929 10.688 19.3959 8.56278 20.3159C6.74157 21.105 5.56522 22.9508 5.56522 25.0199Z",
  fill: "current"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16 16.7472C19.5833 16.7472 22.2609 12.9079 22.2609 9.47443C22.2609 5.86498 19.4525 2.90909 16 2.90909C12.5475 2.90909 9.73913 5.86498 9.73913 9.47443C9.73913 12.9079 12.4167 16.7472 16 16.7472Z",
  fill: "current"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0.695652 7.27273C1.08035 7.27273 1.3913 6.94764 1.3913 6.54545V1.45455H6.26087C6.64557 1.45455 6.95652 1.12945 6.95652 0.727273C6.95652 0.325091 6.64557 0 6.26087 0H0.695652C0.310957 0 0 0.325091 0 0.727273V6.54545C0 6.94764 0.310957 7.27273 0.695652 7.27273Z",
  fill: "current"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M31.3043 0H25.7391C25.3544 0 25.0435 0.325091 25.0435 0.727273C25.0435 1.12945 25.3544 1.45455 25.7391 1.45455H30.6087V6.54545C30.6087 6.94764 30.9197 7.27273 31.3043 7.27273C31.689 7.27273 32 6.94764 32 6.54545V0.727273C32 0.325091 31.689 0 31.3043 0Z",
  fill: "current"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M6.26087 30.5455H1.3913V25.4545C1.3913 25.0524 1.08035 24.7273 0.695652 24.7273C0.310957 24.7273 0 25.0524 0 25.4545V31.2727C0 31.6749 0.310957 32 0.695652 32H6.26087C6.64557 32 6.95652 31.6749 6.95652 31.2727C6.95652 30.8705 6.64557 30.5455 6.26087 30.5455Z",
  fill: "current"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M31.3043 24.7273C30.9197 24.7273 30.6087 25.0524 30.6087 25.4545V30.5455H25.7391C25.3544 30.5455 25.0435 30.8705 25.0435 31.2727C25.0435 31.6749 25.3544 32 25.7391 32H31.3043C31.689 32 32 31.6749 32 31.2727V25.4545C32 25.0524 31.689 24.7273 31.3043 24.7273Z",
  fill: "current"
});

function SvgOrderPosture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderPosture);
export default __webpack_public_path__ + "static/media/OrderPosture.f513212f.svg";
export { ForwardRef as ReactComponent };